import { Button } from "@mui/material";
import { InShellStatus } from "src/components/InShellStatus/InShellStatus";

interface ModuleAccessUnavailableProps {
  /** Reloads the session; omitted when retrying can't help (auth disabled). */
  onRetry?: () => void;
}

/**
 * Shown in the shell's content area when a page needs an entitlement but the
 * session failed to load, so access can't be checked. Distinct from
 * ModuleAccessDenied: this is an outage, not a missing permission.
 */
export function ModuleAccessUnavailable({ onRetry }: ModuleAccessUnavailableProps) {
  return (
    <InShellStatus
      title="We couldn't check your access"
      action={
        onRetry && (
          <Button variant="contained" onClick={onRetry}>
            Retry
          </Button>
        )
      }
    >
      Your session didn&apos;t load, so this page can&apos;t be shown right now.
    </InShellStatus>
  );
}
